import { WORKSPACES, WorkspaceConfig } from 'config/workspaces';

import type { MembershipCatalog } from 'models';

// key, host or origin -> workspace, e.g. "odca", "odca.localhost:3001", "http://odca.localhost:3001"
// and "https://odca.localhost:3001" all map to the odca workspace.
const LOOKUP: Record<string, WorkspaceConfig> = {};

Object.values(WORKSPACES).forEach((workspace) => {
    LOOKUP[workspace.key] = workspace;

    workspace.hosts.forEach((host) => {
        LOOKUP[host] = workspace;
        LOOKUP[`http://${host}`] = workspace;
        LOOKUP[`https://${host}`] = workspace;
    });
});

// Resolves keys, hosts and origins to workspaces using only the URL configuration in `config/workspaces`.
const WorkspaceHelpers = {
    getConfig: (keyOrHost?: string | null): WorkspaceConfig | null => {
        return LOOKUP[(keyOrHost || '').toLowerCase()] || null;
    },

    // A partner workspace key, host or origin. The main site (DEP) has a workspace document too but is not one.
    isWorkspace: (keyOrHost?: string | null): boolean => {
        const workspace = WorkspaceHelpers.getConfig(keyOrHost);

        return workspace !== null && !workspace.main;
    },

    origins: (): string[] => Object.keys(LOOKUP).filter((entry) => entry.includes('://')),

    // The origin of a workspace's primary domain.
    getMainDomain: (key: string): string | undefined => {
        const workspace = WorkspaceHelpers.getConfig(key);

        return workspace ? `https://${workspace.primary}` : undefined;
    },

    // The main site serves every catalog; a partner workspace only its own.
    servesCatalog: (keyOrHost: string | null | undefined, catalog: MembershipCatalog): boolean => {
        return !WorkspaceHelpers.isWorkspace(keyOrHost) || WorkspaceHelpers.getConfig(keyOrHost)?.key === catalog;
    },
};

export { WorkspaceHelpers };
